import { properties } from "@repoflow/common/schema-fields";
import { orgId, domain, status, description, domainId } from "@common/schema/organization/fields";

export default [
  {
    id: "/Public/Organization",
    type: "object",
    properties: {
      ...properties,
      orgId,
      domain,
      status,
      description, 
      domainId
    },
  },
  {
    id: "/Public/Organization/Create",
    type: "object",
    properties: {
      description
    },
    required: ["description"],
  },
  {
    id: "/Public/Organization/Update",
    type: "object",
    properties: {
      description
    },
  },
];
